export {
    HeadTagsProvider,
    useHeadTags,
    useHead,
    HeadTagsInjector,
    markSsrHeadTags,
    SSR_HEAD_ATTR,
} from './HeadTagsContext';
export type { HeadTags } from './HeadTagsContext';

export function escapeAttr(s: string): string {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
